import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { OverdueRow } from './overdueFollowups';

export function useOverdueFollowups() {
  return useQuery<OverdueRow[]>({
    queryKey: ['leads', 'overdue-followups'],
    queryFn: async () => {
      const res = await api.get<{ data: OverdueRow[] }>('/leads/overdue-followups');
      return res?.data ?? [];
    },
    staleTime: 30_000,
  });
}
